import {IComponentOptions, IOnDestroy} from "angular";
import template from "./AveragePriceUpdateRequestLinkComponent.html";
import {OmAveragePriceUpdateRequestDialog} from "app/skin/om/dialog/service/OmAveragePriceUpdateRequestDialog";
import {EquityPositionViewModel} from "../../../../account/equity/models/EquityPositionViewModel";
import {ComponentCallback} from "../../../../types/AngularJS";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {FeatureNames} from "../../../../types/UserConfig";
import {Observable, ReplaySubject} from "rxjs";
import {PortfolioType} from "../../../../portfolio/models/Portfolio";

export const AveragePriceUpdateRequestLink = "tfAveragePriceUpdateRequestLink";

export function averagePriceUpdateRequestLink(): IComponentOptions {
    return {
        template,
        bindings: {
            position: "<",
            onUpdate: "&"
        },
        transclude: true,
        controllerAs: "ctrl",
        controller: AveragePriceUpdateRequestLinkComponent
    };
}

export class AveragePriceUpdateRequestLinkComponent implements IOnDestroy {

    /** @input */
    public readonly position: EquityPositionViewModel | null;

    /** @output */
    public readonly onUpdate: ComponentCallback;

    public readonly hasAveragePriceUpdate$: Observable<boolean>;

    private readonly destroy$ = new ReplaySubject(1);

    /** @ngInject */
    public constructor(private readonly omAveragePriceUpdateRequestDialog: OmAveragePriceUpdateRequestDialog,
                       private readonly currentUserService: CurrentUserService) {

        this.hasAveragePriceUpdate$ = this.currentUserService
                                          .current
                                          .takeUntil(this.destroy$)
                                          .map((user) =>
                                                   user.hasFeature(FeatureNames.AVERAGE_PRICE_UPDATE)
                                                   && this.isUpdateAvailable()
                                          );
    }

    public isUpdateAvailable(): boolean {
        return this.position?.portfolioType === PortfolioType.BROKER;
    }

    public async openAveragePriceUpdateRequestDialog() {
        if (this.position != null && this.isUpdateAvailable()) {
            try {
                await this.omAveragePriceUpdateRequestDialog.open(this.position);
                this.onUpdate();
            } catch (e) {
                // Dialog dismissed
            }
        }
    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
